<template>
  <div>
    <div class="side-sidebar">
      <div class="container-fluid display-table">
        <div class="row display-table-row">
          <div v-if="isMobile" class="position-fixed mobile-toggle">
            <img
              @click="toggleSidebar()"
              width="30"
              height="30"
              class="right-icon"
              src="@/assets/images/home/mobile/double-right.svg"
            />
          </div>
          <div
            :class="{
              'show-sidebar-mobile': isShowSideBarMobile,
              'hide-sidebar-mobile': !isShowSideBarMobile,
            }"
            class="fadeInLeft col-md-2 col-sm-1 hidden-xs display-table-cell v-align box sidebar bg-light border-right"
            id="navigation"
          >
            <div class="logo mt-2">
              <div
                v-if="isMobile"
                @click="toggleSidebar()"
                class="position-absolute"
                style="right: 16px; top: 0px"
              >
                <img
                  width="75"
                  height="75"
                  src="@/assets/images/home/mobile/square.svg"
                />
              </div>
              <h4 class="text-dark">Dashboard</h4>
            </div>
            <div class="navi mt-5">
              <ul>
                <li
                  v-for="(item, key) in dahsboardMenu"
                  :key="key"
                  @click="
                    select = item.currentActive;
                    toggleSidebar();
                  "
                  :class="{ active: select === item.currentActive }"
                >
                  <router-link
                    :class="{ 'text-dark': select !== item.currentActive }"
                    class="text-decoration-none font-weight-bold border-0 pt-2 pb-2 rounded-right mr-1"
                    v-if="item.currentActive !== 'laboratory'"
                    :to="item.url"
                  >
                    <i class="fa fa-home" aria-hidden="true"></i>
                    <span class="hidden-xs hidden-sm">{{ item.name }}</span>
                  </router-link>
                  <router-link
                    :class="{ 'text-dark': select !== item.currentActive }"
                    class="text-decoration-none font-weight-bold border-0 pt-2 pb-2 rounded-right mr-1"
                    v-if="item.currentActive === 'laboratory' && isAdminLab"
                    :to="item.url"
                    @click.native="gotoLabDetail"
                  >
                    <i class="fa fa-home" aria-hidden="true"></i>
                    <span class="hidden-xs hidden-sm">{{ item.name }}</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-10 col-sm-11 display-table-cell v-align m-0 p-0">
            <navbar
              v-if="select !== 'home'"
              :isVisibleSearch="false"
              :isShowLine="false"
              class="nav-dashboard"
            />
            <div class="mb-2 ">
              <div class="text-left adminName " style="left:82% ; top:2%">
                <!-- router view components -->
                <router-view />
                <!-- router view components -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Button trigger modal -->
      <!-- Modal -->
      <div class="footer-style">
        <myfooter />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import mixinConnection from "../../../mixins/mixinsConnection";
import myfooter from "../../home/footer.vue";
import navbar from "../../home/topbar.vue";
export default {
  name: "userDashbord",
  data: () => ({
    select: "home",
    error: "",
    me: "",
    isShowSideBarMobile: false,
    dahsboardMenu: {
      search: {
        name: "Cari Lab",
        currentActive: "home",
        url: "/userDashbord/search",
      },
      bookmark: {
        name: "Bookmark",
        currentActive: "bookmark",
        url: "/userDashbord/Bookmark",
      },
      enquery: {
        name: "Kontak",
        currentActive: "enquery",
        url: "/userDashbord/enquery",
      },
      profil: {
        name: "Profil",
        currentActive: "setting",
        url: "/userDashbord/profile",
      },
      lab: {
        name: "Pengaturan Lab",
        currentActive: "laboratory",
        url: "/userDashbord/lab-detail",
      },
    },
  }),
  mixins: [mixinConnection],

  components: {
    navbar,
    myfooter,
  },

  computed: {
    ...mapGetters(["userPriviledgeStatus"]),

    userStatus() {
      return this.userPriviledgeStatus;
    },

    isAdminLab() {
      return this.userPriviledgeStatus.id_akreditasi?.length > 1;
    },

    isMobile() {
      return window.innerWidth <= 768;
    },
  },

  created() {
    this.getUserPriviledgeStatus();
  },
  watch: {
    select: function() {
      let current = { position: this.select };
      this.$store.dispatch("addStatusDashboard", current);
    },
  },

  mounted() {
    if (window.$cookies.get("KEY_SHA")?.length > 10) {
      this.$router.push({ path: "/internal-dashboard/search/" });
    }
  },

  methods: {
    ...mapMutations(["setLabDetailId"]),
    gotoLabDetail() {
      this.setLabDetailId(this.userStatus.id_lab);
    },

    toggleSidebar() {
      this.isShowSideBarMobile = !this.isShowSideBarMobile;
    },
  },
};
</script>
<style src="@/assets/css/dashboard.css"></style>
<style scoped src="@/assets/css/userDashbord.css"></style>

<style scoped lang="scss">
@import url("../../../assets/css/animation.scss");
.footer-style {
  margin-top: 700px;
  margin-left: 18vw;
  max-width: 70%;
}

.nav-dashboard {
  height: 80px;
  margin-bottom: 60px;
}

.side-sidebar {
  background: #f5f5f5 !important;
}
</style>
